import { createRouter, createWebHistory } from 'vue-router'
import HomeView from './views/HomeView.vue'
import FindView from './views/FindView.vue'
import VenueDetailView from './views/VenueDetailView.vue'
import ActivityDetailView from './views/ActivityDetailView.vue'
import LoginView from './views/LoginView.vue'
import MeView from './views/MeView.vue'
import MyActivitiesView from './views/MyActivitiesView.vue'
import MyVenuesView from './views/MyVenuesView.vue'
import MyOrdersView from './views/MyOrdersView.vue'
import PublishActivityView from './views/PublishActivityView.vue'
import ProfileEditView from './views/ProfileEditView.vue'
import BookingCheckoutView from './views/BookingCheckoutView.vue'
import BookingOrderView from './views/BookingOrderView.vue'
import { authState } from './services/auth'
import { routeAccessDecision } from './services/route-access'

export const router = createRouter({
  history: createWebHistory('/app/'),
  scrollBehavior: () => ({ top: 0 }),
  routes: [
    { path: '/', name: 'home', component: HomeView },
    { path: '/find', name: 'find', component: FindView },
    { path: '/venues/:id', name: 'venue-detail', component: VenueDetailView },
    { path: '/booking/checkout', name: 'booking-checkout', component: BookingCheckoutView, meta: { auth: true } },
    { path: '/booking/orders/:id', name: 'booking-order', component: BookingOrderView, meta: { auth: true } },
    { path: '/activities/new', name: 'publish-activity', component: PublishActivityView, meta: { auth: true } },
    { path: '/activities/:id/edit', name: 'edit-activity', component: PublishActivityView, meta: { auth: true } },
    { path: '/activities/:id', name: 'activity-detail', component: ActivityDetailView },
    { path: '/login', name: 'login', component: LoginView },
    { path: '/me', name: 'me', component: MeView, meta: { auth: true } },
    { path: '/me/profile', name: 'profile-edit', component: ProfileEditView, meta: { auth: true } },
    { path: '/me/activities', name: 'my-activities', component: MyActivitiesView, meta: { auth: true } },
    { path: '/me/venues', name: 'my-venues', component: MyVenuesView, meta: { auth: true } },
    { path: '/me/orders', name: 'my-orders', component: MyOrdersView, meta: { auth: true } },
    { path: '/:pathMatch(.*)*', redirect: '/' },
  ],
})

router.beforeEach((to) => routeAccessDecision({
  requiresAuth: Boolean(to.meta.auth),
  isLoginRoute: to.name === 'login',
  fullPath: to.fullPath,
  authenticated: Boolean(authState.value),
}))
